import { trackAnalyticsEvent } from '@utils/analytics/events/track-event'
import { CheckoutEventDTO, CheckoutEventTypes } from '../../../../types/analytics/analytics-data'
import { detectSiteDomain } from '@utils/detect-site-domain'
import { createBeginCheckoutDTO } from '@utils/analytics/events/checkout/begin-checkout'
import { createPurchaseDTO } from '@utils/analytics/events/checkout/purchase'
import { createAddPaymentInfoDTO } from '@utils/analytics/events/checkout/add-payment-info'
import { createAddShippingInfoDTO } from '@utils/analytics/events/checkout/add-shipping-info'
import { CheckoutState } from '@hooks/use-checkout'
import { Cart } from '../../../../types'

/**
 * Tracks an event by sending it into the datalayer, specifically events related
 * to product analytics such as: view_item, view_item_list, and select_item
 * @param inputData
 * @param eventType
 * @param promoCode
 * @param transactionId
 * @param paymentType
 * @param shippingType
 * @param previousRoute
 */
export const sendCheckoutAnalyticsEvent = (
  inputData: Cart | CheckoutState,
  eventType: CheckoutEventTypes,
  promoCode?: string,
  transactionId?: string,
  paymentType?: string,
  shippingType?: string,
  previousRoute?: string,
) => {
  const siteDomainInfo = detectSiteDomain()

  let checkoutEventDTO: CheckoutEventDTO | undefined
  let fbqEvent = ''

  switch (eventType) {
    case CheckoutEventTypes.BEGIN_CHECKOUT:
      checkoutEventDTO = createBeginCheckoutDTO(inputData as Cart, siteDomainInfo, promoCode, previousRoute)
      if (!siteDomainInfo.synsisalSite) {
        fbqEvent = 'InitiateCheckout'
      }
      break

    case CheckoutEventTypes.ADD_PAYMENT_INFO:
      checkoutEventDTO = createAddPaymentInfoDTO(
        inputData as CheckoutState,
        siteDomainInfo,
        promoCode,
        paymentType,
        previousRoute,
      )
      break

    case CheckoutEventTypes.ADD_SHIPPING_INFO:
      checkoutEventDTO = createAddShippingInfoDTO(
        inputData as CheckoutState,
        siteDomainInfo,
        promoCode,
        shippingType,
        previousRoute,
      )
      break

    case CheckoutEventTypes.PURCHASE:
      checkoutEventDTO = createPurchaseDTO(
        inputData as CheckoutState,
        siteDomainInfo,
        promoCode,
        transactionId,
        previousRoute,
      )
      break
  }

  if (checkoutEventDTO) {
    trackAnalyticsEvent(checkoutEventDTO, fbqEvent)
  }
}
